import {
  IntegrationError,
  PreconditionError,
} from '@buf/dentechse_patient-api-gateway.grpc_web/api/patient/v1/request_failure_pb'
import { isUndefined } from './typeGuards'
import { ErrorType } from './messageHandler'

/**
 * Determines error type based on preconditionError and integrationError
 * @param preconditionError - Precondition error code
 * @param integrationError - Integration error code
 * @returns Error type or undefined if both parameters are undefined
 */
export const determineErrorType = (
  preconditionError: number | undefined,
  integrationError: number | undefined
): ErrorType | undefined => {
  if (isUndefined(preconditionError) || isUndefined(integrationError)) {
    return undefined
  }

  let errorType: ErrorType = Object.keys(PreconditionError)[
    PreconditionError.PRECONDITION_ERROR_UNSPECIFIED
  ] as ErrorType

  if (preconditionError !== PreconditionError.PRECONDITION_ERROR_UNSPECIFIED) {
    errorType = Object.keys(PreconditionError)[preconditionError] as ErrorType
  }

  if (integrationError !== IntegrationError.INTEGRATION_ERROR_UNSPECIFIED) {
    errorType = Object.keys(IntegrationError)[integrationError] as ErrorType
  }

  return errorType
}
